import { isProduction } from './commons/environment';

export const WORKSPACES_PATH = '/workspaces';

export const ORGANIZATION_ROLE = {
  Superuser: 'Superuser',
  Owner: 'Owner',
  Admin: 'Admin',
  Publisher: 'Publisher',
  ReadOnly: 'ReadOnly',
  Editor: 'Editor',
};

export enum MONITORING_SERVICES {
  Sentry = 'Sentry',
}

export enum ENDPOINTS {
  'analyticQueries' = '/api/analyticQueries',
  'applications' = '/api/applications',
  'applicationSensitives' = '/api/applicationSensitives',
  'applicationTraits' = '/api/applicationTraits',
  'assets' = '/api/assets',
  'assetsConfig' = '/api/assetsConfig',
  'assetsConfigHistory' = '/api/assetsConfigHistory',
  'auth' = '/api/auth',
  'autoComplete' = '/api/autoComplete',
  'canduWebhook' = '/api/canduWebhook',
  'canduWebhookLogs' = '/api/canduWebhookLogs',
  'cartography' = '/api/cartography',
  'changeApplication' = '/api/changeApplication',
  'codeBuild' = '/api/codeBuild',
  'collections' = '/api/collections',
  'collectionContent' = '/api/collectionContent',
  'collectionCount' = '/api/collectionCount',
  'contracts' = '/api/contracts',
  'contentDashboard' = '/api/contentDashboard',
  'contentDocumentArchive' = '/api/contentDocumentArchive',
  'contentFolder' = '/api/contentFolder',
  'contentMetadata' = '/api/contentMetadata',
  'contentPlacements' = '/api/contentPlacements',
  'contentQuery' = '/api/contentQuery',
  'contentSegments' = '/api/contentSegments',
  'contentSegmentDocument' = '/api/contentSegmentDocument',
  'contentPublishProgress' = '/api/contentPublishProgress',
  'contentPublishStatus' = '/api/contentPublishStatus',
  'contentViews' = '/api/contentViews',
  'convoyAutoscale' = '/api/convoyAutoscale',
  'convoyDeployments' = '/api/convoyDeployments',
  'convoyMetrics' = '/api/convoyMetrics',
  'convoyServices' = '/api/convoyServices',
  'customerInvites' = '/api/customerInvites',
  'customers' = '/api/customers',

  'dashboardMetrics' = '/api/dashboardMetrics',
  'documentsEditor' = '/api/documentsEditor',
  'documentHistory' = '/api/documentHistory',
  'documentsSdk' = '/api/documentsSdk',
  'dockyardTaskInstances' = '/api/dockyardTaskInstances',

  'emailVerification' = '/api/emailVerification',
  'entitlements' = '/api/entitlements',
  'entitlementsUsage' = '/api/entitlementsUsage',
  'entityPermission' = '/api/entityPermission',
  'entityPermissionAudit' = '/api/entityPermissionAudit',
  'experiments' = '/api/experiments',
  'experimentMetrics' = '/api/experimentMetrics',
  'experimentPreviewLink' = '/api/experimentPreviewLink',
  'experimentStats' = '/api/experimentStats',
  'experimentVariants' = '/api/experimentVariants',

  'fireTestEvent' = '/api/fireTestEvent',
  'flares' = '/api/flares',
  'fonts' = '/api/fonts',
  'fontFamilies' = '/api/fontFamilies',
  'fontsUpload' = '/api/fonts/upload',
  'forms' = '/api/forms',
  'formFields' = '/api/formFields',
  'formResponses' = '/api/formResponses',
  'formResponseCount' = '/api/formResponseCount',
  'formMostRecentSubmission' = '/api/mostRecentFormSubmission',
  'funnels' = '/api/funnels',
  'funnelAnalytics' = '/api/funnelAnalytics',

  'goals' = '/api/goals',
  'goalAnalytics' = '/api/goalAnalytics',

  'hubspotCompany' = '/api/hubspotCompany',

  'identityVerificationSecrets' = '/api/identityVerificationSecrets',
  'images' = '/api/images',
  'impersonationLogs' = '/api/impressionLogs',
  'integrationDefinitions' = '/api/integrationDefinitions',
  'integrations' = '/api/integrations',

  'media' = '/api/media',
  'mediaUpload' = '/api/media/upload',
  'mostRecentContentView' = '/api/mostRecentContentView',

  'oAuth' = '/api/oAuth',
  'offerings' = '/api/offerings',
  'organizationPlans' = '/api/organizationPlans',
  'organizations' = '/api/organizations',

  'paddleboardDeployments' = '/api/paddleboardDeployments',
  'paddleboardServices' = '/api/paddleboardServices',
  'paddleboardRevisions' = '/api/paddleboardRevisions',
  'paddleboardRecentContent' = '/api/recentlyPublishedContent',
  'previewLink' = '/api/previewLink',

  'redemptionCode' = '/api/redemptionCode',

  'schemas' = '/api/schemas',
  'sdkAssets' = '/api/sdkAssets',
  'sdkInstallationStatus' = '/api/sdkInstallationStatus',
  'sdkLatestVersion' = '/api/sdkVersion',
  'segmentAnalytics' = '/api/segmentAnalytics',
  'segmentsDefinition' = '/api/segmentsDefinition',
  'segmentMemberships' = '/api/segmentMemberships',
  'segmentStats' = '/api/segmentStats',
  'segmentUsers' = '/api/segmentUsers',
  'segmentUsages' = '/api/segmentUsages',
  'snapshots' = '/api/snapshots',
  'sourceCSVUpload' = '/api/sourcesContent/uploadCSV',
  'ssoAuth' = '/api/ssoAuth',
  'stripeBillingHistory' = '/api/stripeBillingHistory',
  'styleguideProcessor' = '/api/styleguide-processor',
  'styleguideVariants' = '/api/styleguideVariants',
  'subscriptions' = '/api/subscriptions',

  'templateDocumentsEditor' = '/api/templateDocumentsEditor',
  'templateMetadata' = '/api/templateMetadata',
  'tiers' = '/api/tiers',

  'userProperties' = '/api/userProperties',
  'userTraitsWithTypes' = 'api/dashboardUserTraitsWithTypes',

  'validateCorsDomain' = '/api/validateCorsDomain',
}

export const CANDU_CLIENT_TOKEN = 'BAk3BLFgQrHZ3wkM';

export const AUTH0 = {
  scope: 'openid%20profile%20email',
  canduUrl: 'https://candu.eu.auth0.com',
  clientId: 'K6SJx07RjxP7WHfLToyw1PPalHPuYg62',
};

export const MONITORING = {
  sentry: {
    PUBLIC_KEY: '83d6ac18862d49e0a37f60abe04bc64f',
    HOST: 'sentry.io',
    PROJECT_ID: '1408230',
  },
};

export const FEATUREFLAGS = {
  ld: {
    production: {
      clientSideId: '5f4ea52b12b60c0966b7877e',
    },
    test: {
      clientSideId: '5f4ea52b12b60c0966b7877d',
    },
  },
};

export const STYLEGUIDE_CONFIG = {
  MASTER_TEMPLATE: {
    ORG_ID: 1,
    SLUG: 'master-template',
  },
  DEFAULT_SLUG: 'default',
};

export const LOGGED_IN_HOMEPAGE = '/';

const imageBucket = 'https://images.candu.ai/www';
export const API_URL = !isProduction ? 'http://localhost:3000' : 'https://api.candu.ai';
export const APP_URL = !isProduction ? 'http://localhost:3000' : 'https://app.candu.ai';
export const CDN_PATH = 'https://cdn.candu.ai/www/';
export const MARKETING_SITE_PATH = 'https://www.candu.ai';
export const EXTENSION_LINK =
  'https://chrome.google.com/webstore/detail/candu-for-chrome-%E2%80%94-native/gpnmpnhiimfmafenhcojmfaejljffhpn';

export const INSTALL_CANDU_LINK = 'https://developers.candu.ai/docs/installing-candu';

export const WEBHOOKS_HELP_LINK = 'https://developers.candu.ai/docs/setting-up-outgoing-webhooks';

export const REST_API_LINK =
  'https://developers.candu.ai/docs/get-data-into-candu-via-the-rest-api';

export const SEGMENT_DESTINATION_LINK =
  'https://segment.com/docs/connections/destinations/catalog/candu/';

export const s3Image = (path: string) => `${imageBucket}${path}`;

export const VIEWPORTS = {
  xs: 325,
  sm: 400,
  md: 768,
  lg: 1024,
  xl: 1366,
};

export const MAGIC_LINK_RULES = {
  CRUISE: 'Cruise',
  DASHBOARD: 'Dashboard',
};
